import { useState, useMemo, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import GlobalSearch from '../sharedChild/grid/globalSearch';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import product from '../../../src/assets/img/crm_home/main-content/product.png';
import price from '../../../src/assets/img/crm_home/main-content/price.png';
import ProductListing from './productListing';
import PriceListing from './priceListing';
import { priceInputData, productInputData } from '../../shared/constants';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import { getGridDataByModuleKey } from '../../redux/selector';
import Loader from '../../shared/component/Loader';
import { useSelector } from 'react-redux';

export const Products = () => {
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const navigate = useNavigate();
  const location = useLocation();
  const [isTabActive, setIsTabActive] = useState('products');
  const gridDataProduct = useSelector(getGridDataByModuleKey('productList'));
  const gridDataPriceSheet = useSelector(getGridDataByModuleKey('priceSheetList'));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location.pathname.includes('/priceSheet')) {
      setIsTabActive('priceSheet');
    } else if (location.pathname.includes('/productList')) {
      setIsTabActive('products');
    }
  }, [location.pathname]);

  const handleIsTabActive = (tab) => {
    if (tab === 'priceSheet' && location.pathname !== '/products/priceSheet') {
      navigate('/products/priceSheet');
    } else if (tab === 'products' && location.pathname !== '/products/productList') {
      navigate('/products/productList');
    }
    setIsTabActive(tab);
  };

  const handleCreatePriceList = () => {
    navigate('/products/priceSheet/createPriceSheet');
  };

  const handleCreateProduct = () => {
    navigate('/products/productList/createProduct');
  };

   const exportAllProduct = async () => {
      setLoading(true);

      // Ensure filterJson is considered
      const fetchData = {
        ...productInputData,
        pageSize: gridDataProduct?.totalCount,
        searchText: gridDataProduct?.inputPayload?.searchText ? gridDataProduct?.inputPayload?.searchText : null,
        filterJson: gridDataProduct?.inputPayload?.filterJson ? gridDataProduct?.inputPayload?.filterJson : null,
      };

      try {
        const response = await apiServices.exportAllProduct(fetchData);

        if (response?.data && response.status === 200) {
          setLoading(false);
          // const responseText = typeof response.data === "string" ? response.data.trim() : "";

          if (response?.data.includes('Export initiated.')) {
            toast.warning(response?.data); // Show toast
            setLoading(false);
          } else {
            // Convert data to Blob for better handling
            const blob = new Blob([response.data], {
              type: 'text/csv;charset=utf-8;',
            });
            const url = URL.createObjectURL(blob);

            // Create and trigger download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Products.csv');
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            URL.revokeObjectURL(url); // Free memory
          }
        } else {
          console.error('No data received from API.');
          setLoading(false);
        }
      } catch (error) {
        console.error('Error exporting Invoices:', error);
        setLoading(false);
      }
    };

    const exportAllPriceSheet = async () => {
      setLoading(true);

      // Ensure filterJson is considered
      const fetchData = {
        ...priceInputData,
        pageSize: gridDataPriceSheet?.totalCount,
        searchText: gridDataPriceSheet?.inputPayload?.searchText ? gridDataPriceSheet?.inputPayload?.searchText : null,
        filterJson: gridDataPriceSheet?.inputPayload?.filterJson ? gridDataPriceSheet?.inputPayload?.filterJson : null,
      };

      try {
        const response = await apiServices.exportAllPriceSheet(fetchData);

        if (response?.data && response.status === 200) {
          setLoading(false);
          // const responseText = typeof response.data === "string" ? response.data.trim() : "";

          if (response?.data.includes('Export initiated.')) {
            toast.warning(response?.data); // Show toast
            setLoading(false);
          } else {
            // Convert data to Blob for better handling
            const blob = new Blob([response.data], {
              type: 'text/csv;charset=utf-8;',
            });
            const url = URL.createObjectURL(blob);

            // Create and trigger download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Price Sheets.csv');
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            URL.revokeObjectURL(url); // Free memory
          }
        } else {
          console.error('No data received from API.');
          setLoading(false);
        }
      } catch (error) {
        console.error('Error exporting Invoices:', error);
        setLoading(false);
      }
    };

  return (
    <>{loading && <Loader/>}
      <div className="inner-page" style={containerStyle}>
        <div className="dash-container">
          <div className="tbl_container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 ">
                <div className="main-hd tabP">
                  <div className="mob">
                    <div className="pagetitle ">
                      <img src="../assets/images/role-management-icons/left-arrow.png" alt="" />
                      {isTabActive === 'products' ? 'Products' : 'Price List'}
                    </div>
                  </div>
                  <div className="dsk">
                    <div className="pagetitle tabLeft">
                      <div className="nav nav-tabs">
                        <button
                          className={`nav-link ${isTabActive === 'products' ? 'active' : ''}`}
                          type="button"
                          onClick={() => handleIsTabActive('products')}
                        >
                          <img src={product} alt="Products" />
                          Products
                        </button>
                        <button
                          className={`nav-link ${isTabActive === 'priceSheet' ? 'active' : ''}`}
                          type="button"
                          onClick={() => handleIsTabActive('priceSheet')}
                        >
                          <img src={price} alt="Price List" />
                          Price Sheet
                        </button>
                      </div>
                    </div>
                  </div>
                  {isTabActive === 'products' ? (
                    <>
                      <div className="third-div mobView tabAction">
                        <div className="dsk">
                          <GlobalSearch moduleName={'productList'} />
                        </div>
                        <button
                          className="btn btn-outline-primary mobOption export-btn"
                          type="button"
                          onClick={exportAllProduct}
                        >
                          <svg
                            width="16px"
                            height="16px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 5L11.2929 4.29289L12 3.58579L12.7071 4.29289L12 5ZM13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14L13 14ZM6.29289 9.29289L11.2929 4.29289L12.7071 5.70711L7.70711 10.7071L6.29289 9.29289ZM12.7071 4.29289L17.7071 9.29289L16.2929 10.7071L11.2929 5.70711L12.7071 4.29289ZM13 5L13 14L11 14L11 5L13 5Z"
                              fill="#333333"
                            />
                            <path
                              d="M5 16L5 17C5 18.1046 5.89543 19 7 19L17 19C18.1046 19 19 18.1046 19 17V16"
                              stroke="#333333"
                              stroke-width="2"
                            />
                          </svg>{' '}
                          <div className="dsk"> Export</div>
                        </button>

                        <button
                          className="btn btn-primary createTkt"
                          type="button"
                          onClick={handleCreateProduct}
                        >
                          Create Product
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="third-div mobView tabAction">
                        <div className="dsk">
                          <GlobalSearch moduleName={'priceSheetList'} />
                        </div>
                        <button
                          className="btn btn-outline-primary mobOption export-btn"
                          type="button"
                          onClick={exportAllPriceSheet}
                        >
                          <svg
                            width="16px"
                            height="16px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 5L11.2929 4.29289L12 3.58579L12.7071 4.29289L12 5ZM13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14L13 14ZM6.29289 9.29289L11.2929 4.29289L12.7071 5.70711L7.70711 10.7071L6.29289 9.29289ZM12.7071 4.29289L17.7071 9.29289L16.2929 10.7071L11.2929 5.70711L12.7071 4.29289ZM13 5L13 14L11 14L11 5L13 5Z"
                              fill="#333333"
                            />
                            <path
                              d="M5 16L5 17C5 18.1046 5.89543 19 7 19L17 19C18.1046 19 19 18.1046 19 17V16"
                              stroke="#333333"
                              stroke-width="2"
                            />
                          </svg>{' '}
                          <div className="dsk"> Export</div>
                        </button>

                        <button
                          className="btn btn-primary createTkt"
                          type="button"
                          onClick={handleCreatePriceList}
                        >
                          Create Price Sheet
                        </button>
                      </div>
                    </>
                  )}
                </div>

                <div className="mob mb-3 ">
                  <GlobalSearch moduleName={'campaignList'} />
                </div>

                <div className="mob my-2 tabMob">
                  <div className="pagetitle tabLeft">
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <button
                        className={`nav-link ${isTabActive === 'products' ? 'active' : ''}`}
                        id="campaigns-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#campaigns"
                        type="button"
                        role="tab"
                        aria-controls="campaigns"
                        aria-selected="true"
                        onClick={() => handleIsTabActive('products')}
                      >
                        <img src={product} alt="Products" />
                        Products
                      </button>
                      <button
                        className={`nav-link ${isTabActive === 'pricelist' ? 'active' : ''}`}
                        id="smartSq-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#smartSq"
                        type="button"
                        role="tab"
                        aria-controls="smartSq"
                        aria-selected="true"
                        onClick={() => handleIsTabActive('pricelist')}
                      >
                        <img src={price} alt="Price List" />
                        Price List
                      </button>
                    </div>
                  </div>
                </div>

                <div className="tabPage">
                  <div className='tab-content'>
                  {isTabActive === 'products' ? (
                    <div>
                      <ProductListing />
                    </div>
                  ) : (
                    <div>
                      <PriceListing />
                    </div>
                  )}
                </div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;
